<quant-modal [responsiveStyles]="true" (close)="resume()">
  <div class="end-call-early">
    <div class="header">
      <div class="title">
        {{'call.END_CALL_TITLE' | transloco}}
      </div>
      <div class="message">
        {{'call.END_CALL_DESCRIPTION' | transloco}}
      </div>
    </div>
    <div class="actions">
      <quant-button [label]="'call.END_CALL' | transloco" [disabled]="false" hierarchy="destructive-dark" size="lg"
        iconLeading="assets/icons/phone-call-02.svg" (click)="endCall()"></quant-button>
      <quant-button [label]="'call.RESUME' | transloco" [disabled]="false" hierarchy="primary" size="lg"
        iconLeading="assets/icons/play-circle.svg" (click)="resume()"></quant-button>
    </div>
  </div>
</quant-modal>
